import React, { useMemo } from 'react';
import { normalizeProductosMeseroRow } from '../../../utils/productosMeseroReportModel';

const fmt = (n, maxFrac = 2) =>
  n == null || Number.isNaN(n) ? '—' : Number(n).toLocaleString('es-MX', { maximumFractionDigits: maxFrac });

const fmtMoney = (n) =>
  n == null || Number.isNaN(n)
    ? '—'
    : new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n);

/**
 * Vista previa del detallado plano: tabla única 12 columnas (paridad con Excel/PDF).
 */
export default function MeseroPlanoFlatPreview({ rows }) {
  const list = useMemo(
    () => (Array.isArray(rows) ? rows : []).map(normalizeProductosMeseroRow).filter(Boolean),
    [rows]
  );

  const totals = useMemo(
    () =>
      list.reduce(
        (acc, r) => ({
          cantidad: acc.cantidad + Number(r.cantidad ?? 0),
          importe: acc.importe + Number(r.importe ?? 0),
          totalCosto: acc.totalCosto + Number(r.totalCosto ?? 0),
          utilidad: acc.utilidad + Number(r.utilidad ?? 0),
        }),
        { cantidad: 0, importe: 0, totalCosto: 0, utilidad: 0 }
      ),
    [list]
  );

  const upper = (s) => String(s ?? '').trim().toUpperCase();

  return (
    <section className="pm-report-plano-flat-section" aria-label="Detallado plano">
      <div className="pm-report-table-wrap pm-report-table-wrap--plano-flat">
        <table className="pm-report-table pm-report-table--plano-flat">
          <thead>
            <tr>
              <th>familia</th>
              <th>codigo</th>
              <th>nombreProducto</th>
              <th>tipoProducto</th>
              <th className="pm-num">cantidad</th>
              <th className="pm-num">importe</th>
              <th className="pm-num">costo</th>
              <th className="pm-num">costoTotal</th>
              <th className="pm-num">precio</th>
              <th className="pm-num">utilidad</th>
              <th className="pm-num">mesero</th>
              <th>meseroNombre</th>
            </tr>
          </thead>
          <tbody>
            {list.map((r, idx) => {
              let tipoStr = r.tipoProducto || '';
              if (!tipoStr) tipoStr = r.esBebidas ? 'BEBIDA' : 'ALIMENTO';
              return (
                <tr key={`${String(r.codigo)}-${idx}-${String(r.meseroId)}`}>
                  <td>{upper(r.familia)}</td>
                  <td className="pm-mono">{r.codigo}</td>
                  <td>{upper(r.nombre)}</td>
                  <td>{upper(tipoStr)}</td>
                  <td className="pm-num">{fmt(r.cantidad)}</td>
                  <td className="pm-num">{fmtMoney(r.importe)}</td>
                  <td className="pm-num">{fmtMoney(r.costo)}</td>
                  <td className="pm-num">{fmtMoney(r.totalCosto)}</td>
                  <td className="pm-num">{fmtMoney(r.precio)}</td>
                  <td className="pm-num">{fmtMoney(r.utilidad)}</td>
                  <td className="pm-num">{r.meseroId != null && r.meseroId !== '' ? String(r.meseroId) : '—'}</td>
                  <td>{upper(r.meseroNombre)}</td>
                </tr>
              );
            })}
            <tr className="pm-report-plano-total-general">
              <td colSpan={4}>TOTAL GENERAL</td>
              <td className="pm-num">{fmt(totals.cantidad)}</td>
              <td className="pm-num">{fmtMoney(totals.importe)}</td>
              <td />
              <td className="pm-num">{fmtMoney(totals.totalCosto)}</td>
              <td />
              <td className="pm-num">{fmtMoney(totals.utilidad)}</td>
              <td />
              <td />
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}
